export default __webpack_public_path__ + "static/media/violino.3785bcbe.jpg";